<template>
  <div class="info-list">
    <!--导航-->
    <div class="dk-nav">
      <nav-bar title="贷款资讯" url="/home" />
    </div>
    
    <!--贷款资讯列表-->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
    <div style="margin-top: 1px; margin-bottom: 1px;">
      <template v-if="loading">
      <template v-if="info.data">
      <div class="van-cell" style="margin-bottom: 3px;" v-for="item in filterBy(info.data,city)" @click="goUrl('/info/detail/'+item.id)">
        <div class="van-cell__title">
          <span>{{item.title}}</span>
          <div class="van-cell__label van-multi-ellipsis--l2">{{item.description}}</div>
        </div>
      </div>
      </template>
      </template>
      <template v-else>
        <van-loading type="spinner" color="#ff8917" vertical />
      </template>
    </div>
    </van-pull-refresh>

  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
import NavBar from '../../components/NavBar.vue'
export default {
    'name': 'infoList',
    data() {
        return {
          isLoading: false,
          loading: false
        };
    },
    computed: {
        ...mapState({
            city: state => state.cityData.city,
            info: state => state.info.info_list
        })
    },
    methods: {
      ...mapActions(['requestInfos']),
        goUrl(val) {
            return this.$router.push({path: val})
        },
        onClickLeft() {
            this.$router.push({path: '/'});
        },
        filterBy(list,value){
            return list.filter(function(lists){
                if(value == "重庆") {
                  return lists.city.match('市辖区');
                }else{
                  return lists.city.match(value);
                }
            })
        },
        onRefresh() {
          setTimeout(() => {
            this.isLoading = false;
          }, 1000);
        }
    },
    components: {
      NavBar
    },
    mounted() {
      this.requestInfos({"thit":this,"city":this.city});
    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.info-list >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.info-list >>> .van-nav-bar__text {
  color: #fff;
}
.info-list >>> .van-nav-bar__title {
  color: #fff;
}
.info-list >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.info-list >>> .van-nav-bar .van-icon {
  color: #fff;
}
</style>
